import React from 'react';
import { Trophy, X, Coins } from 'lucide-react';
import { Confetti } from '../effects/Confetti';

interface BattleEndScreenProps {
  winner: 'player' | 'ai';
  wagerAmount: number;
  onPlayAgain: () => void;
  onExit: () => void;
}

export function BattleEndScreen({ winner, wagerAmount, onPlayAgain, onExit }: BattleEndScreenProps) {
  const isVictory = winner === 'player';
  const reward = isVictory ? wagerAmount * 2 : 0;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4 z-50">
      {isVictory && <Confetti active={true} />}
      
      <div className={`bg-gradient-to-br ${
        isVictory ? 'from-green-600 to-emerald-500' : 'from-red-600 to-rose-500'
      } p-0.5 rounded-xl max-w-md w-full animate-bounce-gentle`}>
        <div className="bg-gray-900 p-8 rounded-lg text-center">
          {isVictory ? (
            <Trophy className="w-16 h-16 text-yellow-400 mx-auto mb-4" />
          ) : (
            <X className="w-16 h-16 text-red-400 mx-auto mb-4" />
          )}
          
          <h2 className="text-3xl font-bold text-white mb-4">
            {isVictory ? 'Victory!' : 'Defeat'}
          </h2>
          
          <div className="flex items-center justify-center gap-2 mb-6">
            <Coins className="w-5 h-5 text-yellow-400" />
            <span className={`text-xl font-bold ${isVictory ? 'text-green-400' : 'text-red-400'}`}>
              {isVictory ? `+${reward}` : `-${wagerAmount}`} coins
            </span>
          </div>

          <div className="flex gap-4">
            <button
              onClick={onPlayAgain}
              className="flex-1 px-4 py-3 bg-gradient-to-r from-yellow-600 to-amber-500 text-white rounded-lg hover:from-yellow-500 hover:to-amber-400"
            >
              Play Again
            </button>
            <button
              onClick={onExit}
              className="flex-1 px-4 py-3 bg-gray-800 text-gray-300 rounded-lg hover:bg-gray-700"
            >
              Exit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}